import { Card, CardContent, Grid, Typography } from "@mui/material"
import { FileRejection } from "react-dropzone"
import { UpdateSurveyRecordPhoto, useCreateOneSurveyRecordPhotoMutation, useDeleteOneSurveyRecordPhotoMutation, useUpdateOneSurveyRecordPhotoMutation } from "../../generated/graphql"
import useToast from "../../hooks/useToast"
import { downloadRequestStatic, humanizedFileErrors } from "../../services/utils"
import { SurveyRecordProps } from "../../types/types"
import Gallery from "../Gallery/Gallery"
import styles from './SurveyRecordPhotos.module.scss'

export default function SurveyRecordPhotos(props: SurveyRecordProps) {
    const { surveyRecord, refetch, allowed, isNotUserEdit } = props
    const [createMutation] = useCreateOneSurveyRecordPhotoMutation()
    const [updateMutation] = useUpdateOneSurveyRecordPhotoMutation()
    const [deleteMutation] = useDeleteOneSurveyRecordPhotoMutation()
    const { successToast, errorToast, feedback, unknownErrorToast } = useToast()

    const handleDrop = async (acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
        for await (let acceptedFile of acceptedFiles) {
            try {
                successToast(`A adicionar fotografia ${acceptedFile.name} ...`)
                const response = await createMutation({ variables: { input: { surveyRecordPhoto: { surveyRecord: surveyRecord?.id, name: acceptedFile.name, path: acceptedFile } } } })
                if (response?.data?.createOneSurveyRecordPhoto?.id) {
                    successToast(`Fotografia ${acceptedFile.name} Adicionada`)
                } else {
                    errorToast(`Erro ao adicionar fotografia ${acceptedFile.name}`)
                }
            } catch (e) {
                unknownErrorToast()
            }
        }

        if (refetch) {
            refetch()
        }

        rejectedFiles.forEach(rejectedFile => {
            const errors = humanizedFileErrors(rejectedFile.errors)
            errorToast(`Não foi possível adicionar fotografia ${rejectedFile.file.name} verifique ${errors.join(", ")}`)
        })
    }

    const handleDelete = async (image: any) => {
        const response = await deleteMutation({ variables: { input: { id: image.id } } })
        const id = response?.data?.deleteOneSurveyRecordPhoto.id
        feedback(!id, "Fotografia removida com sucesso", "Erro ao remover fotografia")
        if (refetch) refetch()
    }


    const handleUpdate = async (id: string, update: UpdateSurveyRecordPhoto) => {
        const response = await updateMutation({ variables: { input: { id, update } } })
        feedback(!response?.errors?.length, "Foto atualizada.", "Erro ao atualizar foto")
        if (refetch) refetch()
    }

    const handleDownload = (image: any) => {
        downloadRequestStatic(image.path, image.name)
    }

    return (
        <Grid container className={styles.SurveyRecordPhotos}>
            <Card style={{ width: "100%", padding: 20 }}>
                <CardContent>
                    <Typography variant="h4" color="primary">Fotografias</Typography>
                    <Gallery
                        images={surveyRecord?.surveyRecordPhotos}
                        onDrop={handleDrop}
                        onDelete={handleDelete}
                        onDownload={handleDownload}
                        onUpdate={handleUpdate}
                        disableDelete={!allowed || isNotUserEdit}
                        disableAdd={!allowed || isNotUserEdit}
                        disableUpdate={!allowed || isNotUserEdit}
                    />
                </CardContent>
            </Card>
        </Grid>
    )
}

